import {Component} from '@angular/core';
import {NavController, NavParams} from "ionic-angular";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {GlobalProvider} from "../../providers/global/global";
import {RemarkService} from "../../store/remark/remark.service";
import {RemarkEntity} from "../../store/remark/remark.entity";
import {ProtocolService} from "../../store/protocol/protocol.service";

/**
 * Generated class for the BemerkungstextvorlagenComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@AutoUnsubscribe()
@Component({
  selector: 'bemerkungstextvorlagen',
  templateUrl: 'bemerkungstextvorlagen.html'
})
export class BemerkungstextvorlagenComponent {

  public editMode: boolean = false;
  public selectedVorlage: string = null;
  public category: string = null;

  private pruefpunkt: any;
  private protokoll: any;

  // private _bemerkungSubscription: Subscription;

  constructor(private navCtrl: NavController,
              private navParams: NavParams,
              public remarkService: RemarkService,
              private protocolService: ProtocolService,
              public globalProvider: GlobalProvider
  ) {

    this.pruefpunkt = this.navParams.get('pruefpunkt');
    this.selectedVorlage = this.navParams.get('selectedVorlage');
    this.protokoll = this.navParams.get('protokoll');
  }

  public select(vorlage: {title: string, category: string}): void {
    this.editMode = true;
    this.selectedVorlage = vorlage.title;
    this.category = vorlage.category;
  }

  public back(): void {
    this.selectedVorlage = null;
    this.navCtrl.pop();
  }

  public add(): void {
    if(!this.pruefpunkt.comments){
      this.pruefpunkt.comments = [];
    }
    this.pruefpunkt.comments.push(this.selectedVorlage);
    this.protocolService.set(this.protokoll, false);
    // this.dataProvider.updateDocument(this.protokoll);
    this.navCtrl.pop();
  }

  public save(): void {

    const doc: RemarkEntity = {
      docType: 'remark',
      docName: 'Bemerkung',
      title: this.selectedVorlage,
      category: this.category,
      system: false,
    };

    this.remarkService.set(doc, false);

    // this.dataProvider.createDocumentWithoutInit();
    // this.bemerkungstextvorlageProvider.add(this.selectedVorlage);
    this.navCtrl.pop();
  }

  public setCategoryName($event): void {
    this.category = $event;
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }
}



// WEBPACK FOOTER //
// ./src/components/bemerkungstextvorlagen/bemerkungstextvorlagen.ts